<script setup lang="ts">
import RadioButtonController from '@/components/RadioButtonController/RadioButtonController.vue'
import { useTopics } from '@/domains/rodo/composables/useTopicOfCase'
import { useRodoStore } from '@/domains/rodo/store/useRodoStore'

const { topics } = useTopics()

const { topic, step } = useRodoStore()

const setTopic = (event: number) => {
  topic.value = event
  step.value++
}
</script>

<template>
  <RadioButtonController
    class="rodoTopics"
    :model-value="topic"
    :radio-controls="topics"
    variant="vertical"
    @update="setTopic"
  />
</template>

<style lang="scss" scoped>
.rodoTopics {
  max-width: 70rem;
}
</style>
